import './edit-util-age-bracket.scss';

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilAgeBracket from "../form-util-age-bracket/form-util-age-bracket";
import { useEditUtilAgeBracket } from "./edit-util-age-bracket.hook";

export function EditUtilAgeBracket() {
  const {
    utilAgeBracketData,
    isLoading,
    utilAgeBracketError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditUtilAgeBracket();

  const title =
    utilAgeBracketData?.name ? <h1>{ utilAgeBracketData?.name }</h1> : <h1>Edit Util Age Bracket</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormUtilAgeBracket />
      </section>
    </div>
  );

  return (
    <div id="EditUtilAgeBracket" className="util-age-bracket">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { utilAgeBracketError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default EditUtilAgeBracket;